<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script>
import { defineAsyncComponent } from 'vue';

const defaultLayout = "DefaultLayout";

export default {
  name: "MainLayout",

  computed: {
    layout() {
      const layout = this.$route.meta.layout || defaultLayout;
      return defineAsyncComponent(() => import(`@/layouts/${layout}.vue`));
    },
  },
};
</script>